<sliding-panel class="sliding-panel" [exit]="exit">
	<div class="main-container">
		<div class="header-container">
			<div class="title-container">
				<div class="title-container-left">
					@if (historyType() === HistoryLogType.MILESTONE) {
					<span class="panel-title-text-milestone">
						{{ this.panelTitle }}
					</span>
					} @else if (historyType() === HistoryLogType.TRANSACTION) {
					<span class="panel-title-text-black">
						{{ this.panelTitle }}
					</span>
					}
				</div>
				<div class="title-container-exit" aria-hidden="true" (click)="resetSubjects()">
					<span>
						<app-icon
							class="close-btn"
							[name]="'close'"
							[color]="'var(--color-text-default)'"
							[size]="'40'"
							[lineWidth]="'1px'"
						></app-icon>
					</span>
				</div>
			</div>
		</div>
		@if(historyType() === HistoryLogType.MILESTONE) {
		<div class="log-records-tab-filter">
			<mat-tab-group
				class="milestone-type-filter"
				[(selectedIndex)]="activeMilestoneHistoryFilterIndex"
				mat-stretch-tabs="false"
				mat-align-tabs="start"
				animationDuration="0ms"
				(selectedTabChange)="applyFilters()"
			>
				<mat-tab>
					<ng-template mat-tab-label class="tab-label">All</ng-template>
				</mat-tab>
				<mat-tab>
					<ng-template mat-tab-label class="tab-label">Status</ng-template>
				</mat-tab>
				<mat-tab>
					<ng-template mat-tab-label class="tab-label">Calendar errors</ng-template>
				</mat-tab>
			</mat-tab-group>
		</div>
		}

		<form [formGroup]="searchForm">
			<mat-form-field id="historySearch" appearance="outline">
				<app-icon [name]="'search-normal-1'" matPrefix style="padding-right: 10px"></app-icon>
				<input matInput placeholder="Search by" formControlName="searchControl" />
			</mat-form-field>
		</form>

		@if(milestoneHistoryRecordsFiltered.length > 0 && historyType() === HistoryLogType.MILESTONE) {
		<div class="log-records-main-container milestone">
			@for(milestoneHistoryRecord of milestoneHistoryRecordsFiltered; track milestoneHistoryRecord.createdAt) {
			@if (!isCalendarError(milestoneHistoryRecord)) {
			<div class="log-records-container milestone">
				<div class="log-records-container-left">
					<div class="log-records-container-time">
						<span class="log-item-time">
							{{ milestoneHistoryRecord.createdAt | date : "HH:mm" }}
							{{ milestoneHistoryRecord.createdAt | date }}</span
						>
					</div>
					<div class="log-records-container-status">
						<span
							[ngClass]="{'status-dot-complete': milestoneHistoryRecord.status === 'COMPLETE',
					'status-dot-inprogress' :milestoneHistoryRecord.status === 'IN_PROGRESS',
					'status-dot-pending' :milestoneHistoryRecord.status === 'PENDING',
					'status-dot-errors' :milestoneHistoryRecord.status === 'ERROR',
					}"
						></span>

						<span class="history-log-status log-item-black">
							{{ milestoneHistoryRecord.status! | milestoneStatuses | uppercase }}
						</span>
					</div>
				</div>
				<div class="log-records-container-right">
					<span class="history-log-title log-item-black">
						@for(segment of milestoneHistoryRecord.title; track segment) { @if(segment.style ===
						"highlight") {
						<span class="log-item-blue"> {{ segment.text }}</span>
						} @else {
						{{ segment.text }}
						} }
					</span>
				</div>
			</div>
			} @else {
			<div class="calendar-error-list" [attr.data-test]="'calendar-errors-side-panel-error-list'">
				<div class="calendar-error-item" [attr.data-test]="'calendar-errors-side-panel-error-item'">
					<div class="calendar-error-item-log">
						<span class="item-log-time" [attr.data-test]="'calendar-errors-side-panel-error-item-log-time'"
							>{{ milestoneHistoryRecord.createdAt | date : "HH:mm" }}
							{{ milestoneHistoryRecord.createdAt | date }}</span
						>
						<span
							class="item-log-type"
							[attr.data-test]="'calendar-errors-side-panel-error-item-log-type'"
							>{{ milestoneHistoryRecord.errorType }}</span
						>
					</div>

					<div
						class="calendar-error-item-content"
						[attr.data-test]="'calendar-errors-side-panel-error-item-content'"
					>
						<h3 class="item-title" [attr.data-test]="'calendar-errors-side-panel-error-item-title'">
							{{ milestoneHistoryRecord.title }}
						</h3>
						<p class="item-subtitle" [attr.data-test]="'calendar-errors-side-panel-error-item-subtitle'">
							<img
								class="item-flag"
								src="assets/svg-country-flags/svg/{{ milestoneHistoryRecord.flag?.toLowerCase() }}.svg"
							/>
							{{ milestoneHistoryRecord.subtitle }}
						</p>
						<p
							class="item-description"
							[attr.data-test]="'calendar-errors-side-panel-error-item-description'"
						>
							{{ milestoneHistoryRecord.errorDescription }}
						</p>
						@if (milestoneHistoryRecord.hasCalendarLink) {
						<button
							class="item-link"
							type="button"
							(click)="
								goToCalendar(
									milestoneHistoryRecord.payGroupId!,
									milestoneHistoryRecord.legalEntityId!,
									milestoneHistoryRecord.customerName!,
									milestoneHistoryRecord.customerId!
								)
							"
							[attr.data-test]="'calendar-errors-side-panel-error-item-link'"
						>
							Go to Calendar <span aria-hidden="true">→</span>
						</button>

						}
					</div>
				</div>
			</div>
			}
			<mat-divider />

			}
		</div>
		} @if(statusHistoryRecordsFilterCopyTransactions.length > 0 && historyType() === HistoryLogType.TRANSACTION) {
		@for(historyRecord of statusHistoryRecordsFilterCopyTransactions; track historyRecord) {
		<div class="log-records-main-container">
			<div class="log-records-container">
				<div class="log-records-container-left">
					<div class="log-records-container-time">
						<span class="log-item-time">
							{{ historyRecord.createdAt | date : "HH:mm" }}
							{{ historyRecord.createdAt | date }}</span
						>
					</div>
					<div class="log-records-container-status">
						<span
							[ngClass]="{
									'status-green':
										(historyRecord.status.name | toString) === 'SUCCESS' ||
										(historyRecord.status.name | toString) === 'PROCESSED',
                                       
									'status-red':
										(historyRecord.status.name | toString) === 'FAILED' ||
										(historyRecord.status.name | toString) === 'ATTEMPTS_LIMIT_EXCEEDED' ||
										(historyRecord.status.name | toString) === 'FAILED_TO_BOOK' ||
										(historyRecord.status.name | toString) === 'ERROR',
									'status-pending':
										(historyRecord.status.name | toString) === 'PENDING' ||
										(historyRecord.status.name | toString) === 'PROCESSING',

									'status-booked': (historyRecord.status.name | toString) === 'BOOKED' || (historyRecord.status.name | toString) === 'REPROCESSED' ,
									'status-cancelled': (historyRecord.status.name | toString) === 'CANCELLED',
									'status-created': (historyRecord.status.name | toString) === 'CREATED',
                                    'status-inactive': (historyRecord.status.name | toString) === 'INACTIVE',
								}"
						></span>

						<span class="history-log-item log-item-black">
							{{ historyRecord.status.name | transactionStatuses }}
						</span>
					</div>
				</div>
				<div class="log-records-container-right">
					<div>
						<span class="history-log-item log-item-grey">
							Transaction ID: {{ historyRecord.transactionId }}
						</span>
					</div>
					<div>
						<span class="history-log-item log-item-black">
							@if ( ( historyRecord.createdBy !== '' && ( historyRecord.status.name.toString() ===
							'INACTIVE' || historyRecord.status.name.toString() === 'PROCESSED' ) ) || (
							historyRecord.createdBy.toLowerCase() !== 'system' && ( historyRecord.status.name.toString()
							=== 'BOOKED' || historyRecord.status.name.toString() === 'PROCESSED' ||
							historyRecord.status.name.toString() === 'REPROCESSED' ) ) ) {
							<span class="log-item-blue">
								{{ historyRecord.createdBy | userFullName | async }}
							</span>
							} @else {
							<span class="log-item-blue">System</span>} has changed the transaction state @if
							(hasEmployeeName(historyRecord)) { of
							<span class="log-item-blue"
								>{{ historyRecord.employeeFirstName + " " + historyRecord.employeeLastName }} </span
							>} @if (historyRecord.employeeExternalId) {with the id
							<span class="log-item-blue">{{ historyRecord.employeeExternalId }}</span
							>} to
							<span class="log-item-blue">{{ historyRecord.status.name | transactionStatuses }}</span>
						</span>
					</div>

					<div>
						@if ( !historyRecord.status.details || isEmptyObject(historyRecord.status.details?.attributes) )
						{
						<span class="history-log-item log-item-grey">
							{{ historyRecord.status.message }}
						</span>
						} @let attributes = historyRecord.status.details?.attributes; @if (attributes &&
						!isEmptyObject(attributes)) {
						<span class="history-log-item log-item-grey">
							Reason: @for (attribute of attributes | keyvalue; track attribute.key) {
							<div class="history-log-item log-item-grey">
								<strong>{{ attribute.key | formatString }}</strong
								>: @if (!isArray(attribute.value + '')) {
								{{ attribute.value }}
								} @if (isArray(attribute.value + '')) {
								<div class="mt-1">
									@for (tag of getArrayValue(attribute.value + ''); track tag) {
									<div class="details-items">
										<strong>{{ attribute.key | formatString }}:</strong>
										{{ tag | formatString }}
									</div>
									}
								</div>
								}
							</div>
							}
						</span>
						}
					</div>
				</div>
			</div>
			<mat-divider />
		</div>
		} } @if ( statusHistoryRecordsFilterCopyTransactions.length === 0 && milestoneHistoryRecordsFiltered.length ===
		0 ) {
		<no-items-layout message="No records to display"></no-items-layout>
		}
	</div></sliding-panel
>
